<template>
  <div>
    <!-- <el-select v-model="operaUser" placeholder="请选择">
    <el-option
      v-for="(item,index) in createByAllArr"
      :key="'people'+index"
      :label="item"
      :value="item">
    </el-option>
  </el-select> -->
   <el-input v-model="operaUser" clearable placeholder="请输入" style="width:300px"></el-input>
    <el-table :data="listData" style="width: 100%">
      <!-- <el-table-column prop="date" label="序号"> </el-table-column> -->
      <el-table-column type="index" :index="indexMethod"> </el-table-column>
      <el-table-column prop="operaUser" label="操作人员"> </el-table-column>
      <el-table-column prop="count" label="审核总量"> </el-table-column>
      <el-table-column prop="address" label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="showDetail(scope.row)">明细</el-button>
        </template>
      </el-table-column>
    </el-table>
    <DetailDialog ref="detailDialog" :show-desc="true"></DetailDialog>
  </div>
</template>
<script>
import api from "../../api";
import DetailDialog from "../DetailDialog.vue";
export default {
  components: {
    DetailDialog
  },
  data() {
    return {
      tableData: [],
      pagination: {
        size: 10,
        page: 1
      },
      audistCount: 0,
      operaUser: "",
      listData: [],
      createByAllArr:[]
    };
  },
  mounted() {
    this.listInit();
    // this.getCreateByAll();
  },
  methods: {
    indexMethod(index) {
      return index + 1;
    },
    handleCurrentChange(pagination) {
      this.$emit("refresh", pagination);
    },
    getCreateByAll() {
      api.getCreateByAll().then(res => {
        this.createByAllArr = res.data;
        this.createByAllArr.unshift("全部")
      });
    },
    showDetail(row) {
      let detailDialog = this.$refs["detailDialog"];
      detailDialog.setVisible(true);
      detailDialog.setInfo(row);
    },
    queryList() {},
    listInit() {
      api
        .getStatisticsList({
          operaUser: this.operaUser === '全部' ? '' : this.operaUser
        })
        .then(res => {
          this.listData = res.data;
        });
    }
  },
  watch: {
    operaUser(newValue, oldValue) {
       this.listInit();
    }
  },
};
</script>
